import { useEffect } from "react";
import { FaKey, FaLock, FaPaperclip, FaShieldAlt, FaAddressBook, FaExclamationTriangle, FaCheckCircle } from "react-icons/fa";
import { PERSONAL_VAULT_CONSTANTS } from "../../_PersonalVault/_MODULES/_API";
import { CONTACTS_CONSTANTS } from "../../_Contacts/_MODULES/_API";
import { CENTER_CONSTANTS } from "../../_Center/_MODULES/_API";
import { PageHeader } from "../../../../../_CORE/APP/Templates/_UI/PageHeader/_index";
import { AppButton } from "../../../../../_CORE/APP/Templates/_UI/Button/_index";
import { MetricCard, MetricGrid } from "../../../../../_CORE/APP/Templates/_UI/Metrics/_index";
import { useApiQuery } from "../../../../../_CORE/APP/Hooks/Hooks/_Records/_useApiQuery";
import { ViewLayout } from "../../../../_UI/ViewLayout";
import "../_UI/_Styles/WorkspaceDashboard.css";

export const SecurityDashboardViewMain = () => {
    const { apiGet, useApiData: groupsData, useApiLoading } = useApiQuery({
        minTimeQuery: 220,
        enablePagination: false,
        startLoading: true,
    });

    const { apiGet: onGetContacts, useApiData: contactsData, useApiLoading: useContactsLoading } = useApiQuery({
        minTimeQuery: 220,
        enablePagination: false,
        startLoading: true,
    });

    const { apiGet: onGetHealth, useApiData: healthData, useApiLoading: useHealthLoading } = useApiQuery({
        minTimeQuery: 220, enablePagination: false, startLoading: true,
    });

    useEffect(() => {
        apiGet({ endpoint: PERSONAL_VAULT_CONSTANTS.GROUP_LIST });
        onGetContacts({ endpoint: CONTACTS_CONSTANTS.LIST });
        onGetHealth({ endpoint: CENTER_CONSTANTS.SECURITY });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const groups = Array.isArray(groupsData) ? groupsData : [];
    const contacts = Array.isArray(contactsData) ? contactsData : [];
    const accessCount = groups.reduce((total, group) => total + Number(group.entries?.length || 0), 0);
    const fileCount = groups.reduce((total, group) => total + Number(group.files?.length || 0), 0);
    const protectedCount = groups.filter((group) => group.hasAccessPin).length;
    const health = healthData || {};

    return (
        <ViewLayout
            header={
                <PageHeader
                    title="Seguridad"
                    description="Resumen de la información sensible que administrás dentro de NOTEBOOK."
                    icon={<FaShieldAlt />}
                    actions={<div className="LStudio__workspace_dashboard_actions">
                        <AppButton to="/personal-vault" icon={<FaShieldAlt />}>Abrir bóveda personal</AppButton>
                        <AppButton to="/contacts" variant="outline" tone="neutral" icon={<FaAddressBook />}>Contactos</AppButton>
                    </div>}
                />
            }
        >
            <section className="LStudio__workspace_dashboard_section">
                <div className="LStudio__workspace_dashboard_heading">
                    <span>Panel de seguridad</span>
                    <small>Estado general de grupos, accesos y archivos protegidos.</small>
                </div>

                <MetricGrid columns="auto">
                    <MetricCard label="Grupos" value={groups.length} icon={<FaShieldAlt />} tone="accent" isLoading={useApiLoading} to="/personal-vault" />
                    <MetricCard label="Accesos" value={accessCount} icon={<FaKey />} tone="neutral" isLoading={useApiLoading} footer="Credenciales organizadas dentro de tus grupos" />
                    <MetricCard label="Archivos" value={fileCount} icon={<FaPaperclip />} tone="neutral" isLoading={useApiLoading} footer="Archivos asociados a la bóveda personal" />
                    <MetricCard label="Con PIN" value={protectedCount} icon={<FaLock />} tone="warn" isLoading={useApiLoading} footer="Grupos que requieren validación adicional" />
                    <MetricCard label="Contactos" value={contacts.length} icon={<FaAddressBook />} tone="neutral" isLoading={useContactsLoading} to="/contacts" footer="Agenda privada cifrada" />
                </MetricGrid>
            </section>

            <section className="LStudio__workspace_dashboard_section">
                <div className="LStudio__workspace_dashboard_heading">
                    <span>Security Health</span>
                    <small>Controles prácticos sobre credenciales y recuperación. Nunca muestra contraseñas ni hashes.</small>
                </div>
                <MetricGrid columns="auto">
                    <MetricCard label="Salud" value={`${health.score ?? 0}%`} icon={<FaShieldAlt />} tone={(health.score ?? 0) >= 80 ? "accent" : "warn"} isLoading={useHealthLoading} />
                    <MetricCard label="Sin pista" value={health.summary?.missingHints ?? 0} icon={<FaKey />} tone="warn" isLoading={useHealthLoading} />
                    <MetricCard label="Tokens próximos" value={health.summary?.expiringTokens ?? 0} icon={<FaExclamationTriangle />} tone="warn" isLoading={useHealthLoading} />
                    <MetricCard label="Contraseñas repetidas" value={health.summary?.duplicatePasswordGroups ?? 0} icon={<FaLock />} tone="warn" isLoading={useHealthLoading} />
                    <MetricCard label="2FA sin recovery" value={health.summary?.twoFactorWithoutRecovery ?? 0} icon={<FaShieldAlt />} tone="neutral" isLoading={useHealthLoading} />
                </MetricGrid>
                <div className="LStudio__security_health_recommendations">
                    {(health.recommendations || []).map((text, index) => <div key={index}><FaExclamationTriangle /><span>{text}</span></div>)}
                    {!useHealthLoading && !(health.recommendations || []).length && <div><FaCheckCircle /><span>No hay observaciones importantes en este momento.</span></div>}
                </div>
            </section>
        </ViewLayout>
    );
};
